var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const experimentsPrefix = "experiments/";
const experimentActionTypes = {
  LOAD_EXPERIMENT: `${experimentsPrefix}LOAD_EXPERIMENT`,
  LOADED_EXPERIMENT: `${experimentsPrefix}LOADED_EXPERIMENT`
};
const loadExperiment = (id) => {
  return {
    id,
    type: experimentActionTypes.LOAD_EXPERIMENT,
    payload: {},
    loading: true,
    // @ts-ignore
    error: null
  };
};
const loadedExperiment = (id, experiment, error, restResult) => {
  return __spreadValues({
    id,
    type: experimentActionTypes.LOADED_EXPERIMENT,
    payload: experiment || {},
    loading: false,
    error
  }, restResult && restResult.errorContext && { errorContext: restResult.errorContext });
};
export {
  experimentActionTypes,
  experimentsPrefix,
  loadExperiment,
  loadedExperiment
};
//# sourceMappingURL=Experiment.ducks.js.map
